import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { errorsInput } from 'src/consts';
import { useTranslation } from 'react-i18next';
import { PrintOnDemandFormInput } from './printOnDemand.types';
import { SMART_COLIS_TRACKING_SHIPPING_OR_COLIS_PATTERN } from 'src/helpers';



export const usePrintOnDemandForm = () => {
    
    const {t} = useTranslation();
    const validationSchema = Yup.object().shape({
        trackingId:Yup.string()
        .matches(SMART_COLIS_TRACKING_SHIPPING_OR_COLIS_PATTERN, t(errorsInput.invalidColiTrackingNumber))
        .required(errorsInput.required),
      });
    
      const formOptions = { resolver: yupResolver(validationSchema) };
    

    const {control,formState:{errors}, handleSubmit, reset, setValue, } = useForm<PrintOnDemandFormInput>(formOptions);
    return {
        handleSubmit,
        control,
        errors,
        resetForm:reset,
        setValue,
    }
}   